import {BASE_URL} from 'appConstants';
import {get, post} from 'sdk';

import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';

export const fetchAllocations = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/for-allocations-calendar/`;

  return get(url, extraGetParams);
};

export const fetchAllocationStatistics = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/for-allocations-statistics/`;

  return get(url, extraGetParams);
};

export const deleteOfflinePeriod = ({offlinePeriodId, locationRef}) => {
  const url = `${BASE_URL}/v2/living/offline-periods/${offlinePeriodId}/delete/`;

  const payload = {location: locationRef};
  return post(url, payload);
};

export const fetchOfflinePeriodReasons = () => {
  const url = `${BASE_URL}/v2/living/offline-periods/reasons/`;

  return get(url);
};

export const fetchRoomsForRoomPurposes = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/purposes/`;

  return get(url, extraGetParams);
};

export const createOfflinePeriod = ({
  room,
  startDate,
  endDate,
  reason,
  notes,
  locationRef
}) => {
  const url = `${BASE_URL}/v2/living/offline-periods/create/`;
  const payload = {
    room,
    startDate,
    endDate,
    reason,
    notes,
    location: locationRef
  };

  return post(url, payload);
};

export const changeRoomCleaningStatus = ({
  cleaningStatus,
  outOfServiceReason,
  roomId,
  locationRef
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/${roomId}/change-cleaning-status/`;

  const payload = {
    cleaningStatus,
    outOfServiceReason
  };
  return post(url, payload);
};

export const exportRoomAllocations = ({locationRef, filters}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/export-allocations-excel/`;

  return get(url, {
    ...transformFiltersForStoreToFiltersForApi(filters)
  });
};

export const fetchOfflinePeriod = ({offlinePeriodId}) => {
  const url = `${BASE_URL}/v2/living/offline-periods/${offlinePeriodId}/details/`;

  return get(url);
};

export const editOfflinePeriodStartDate = ({offlinePeriodId, newStartDate}) => {
  const url = `${BASE_URL}/v2/living/offline-periods/${offlinePeriodId}/edit/start-date/`;
  const payload = {newStartDate};

  return post(url, payload);
};

export const editOfflinePeriodEndDate = ({offlinePeriodId, newEndDate}) => {
  const url = `${BASE_URL}/v2/living/offline-periods/${offlinePeriodId}/edit/end-date/`;
  const payload = {newEndDate};

  return post(url, payload);
};

export const editOfflinePeriodReason = ({
  offlinePeriodId,
  newOfflinePeriodReasonId
}) => {
  const url = `${BASE_URL}/v2/living/offline-periods/${offlinePeriodId}/edit/reason/`;
  const payload = {newOfflinePeriodReason: newOfflinePeriodReasonId};

  return post(url, payload);
};

export const editOfflinePeriodNotes = ({
  offlinePeriodId,
  newOfflinePeriodNotes
}) => {
  const url = `${BASE_URL}/v2/living/offline-periods/${offlinePeriodId}/edit/notes/`;
  const payload = {newOfflinePeriodNotes};

  return post(url, payload);
};

export const fetchRoomHistory = ({locationRef, roomId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/${roomId}/activity-log-history/`;

  return get(url);
};

export const assignRoomPurpose = ({
  rooms,
  startDate,
  endDate,
  purpose,
  locationRef
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/create-purpose/`;
  const payload = {
    rooms,
    startDate,
    endDate,
    purpose
  };

  return post(url, payload);
};

export const getChangesBeforeCreatingRoomPurposes = ({
  locationRef,
  rooms,
  startDate,
  endDate,
  purpose
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/get-changes-before-creating-purpose/`;
  const payload = {
    rooms,
    startDate,
    endDate,
    purpose
  };

  return post(url, payload);
};
